import { Button } from 'blaze-ui/Button'
import { Plus } from 'blaze-ui/icons'
import { useFormikContext } from 'formik'
import { AddFromAnotherSourceButtonProps } from 'components/Wizards/SelectImages/Types'

export const AddFromAnotherSourceButton = ({
  variant = 'secondary',
  size = 'md',
  ...props
}: AddFromAnotherSourceButtonProps) => {
  const { isSubmitting } = useFormikContext()

  return (
    <Button
      isDisabled={isSubmitting}
      variant={variant}
      size={size}
      frontIcon={Plus}
      aria-label="Add Media From Another Source"
      {...props}
    >
      Add From Another Source
    </Button>
  )
}
